import {
	GET_KB_MAKING_DETAILS_REQUEST,
	GET_KB_MAKING_DETAILS_REQUEST_SUCCESS,
	GET_KB_MAKING_DETAILS_REQUEST_FAILED,
	GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR,
} from "../types"

const initialState = {
	isLoading: false,
	kbMakingDetails: {},
}
const bifrostKbMakingDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_KB_MAKING_DETAILS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_KB_MAKING_DETAILS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				kbMakingDetails: action.payload,
			}
		case GET_KB_MAKING_DETAILS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
				kbMakingDetails: {},
			}
		case GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR:
			return initialState

		default:
			return state
	}
}

export default bifrostKbMakingDetailsReducer
